import ChannelAppResource from '@milestoneslabs/milestones-core-js/src/AppResources/ChannelAppResource';
import {ApiFilter, AppResourceSearch} from '@milestoneslabs/milestones-js-engine';
import ChannelMemberAppResource from '@milestoneslabs/milestones-core-js/src/AppResources/ChannelMemberAppResource';
import moment from 'moment';
import router from '../../../router';
import {ALLOWED_ROUTES_PROJECT_NOT_SET} from "./helpers/variables";
import isEmpty from 'lodash/isEmpty';
import UserAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/UserAppResource";

export default {
    /**
     * TODO: redo the temporary fix for allowed routes if project is not set when routes rework is done
     * @param dispatch
     * @param commit
     * @param getters
     * @returns {Promise<*>}
     */
    async initWorkspace({dispatch, commit, getters}) {
        const authUser = getters.getAuthUserAppResource;
        if (
            isEmpty(authUser) ||
            !(authUser instanceof UserAppResource) ||
            !authUser.exists
        ) {
            console.log(
                '%c INFO: In order to access this page you must be signed in.',
                'background: #3D465E; color: #1ACEB3'
            );
            return;
        }

        if (ALLOWED_ROUTES_PROJECT_NOT_SET.includes(router.currentRoute.name)) {
            console.log(
                '%c INFO: You are accessing this page from an external source. No project is set!',
                'background: #3D465E; color: #1ACEB3'
            );
            return;
        }


        const url = new URL(window.location.href);
        const projectUuid = url.searchParams.get('projectUuid');

        const userWorkspaceUuid = !isEmpty(projectUuid) ? projectUuid : authUser.get('lastWorkspaceUuid');

        if (
            isEmpty(userWorkspaceUuid) &&
            router.currentRoute.name !== 'my.projects'
        ) {
            return router.push({
                name: 'my.projects',
            });
        }

        let projectsFilter = new ApiFilter({
            relations: {
                members: new ApiFilter({
                    params: {
                        userUuid: authUser.uuid,
                    }
                }),
            },
        });

        if (!isEmpty(userWorkspaceUuid)) {
            projectsFilter.addParam('uuid', userWorkspaceUuid);
        }

        const workspaceSearch = new AppResourceSearch('workspace');
        workspaceSearch.setSearchData({
            include: [
                'members.user.channels',
                'members.user.avatarFile',
                'members.workspaceMembershipType',
                'propertyInstances',
                'workspaceType.workspaceStageTypes.stageType',
                'organization',
            ],
            pagination: 'disabled',
            limit: 1,
            filter: projectsFilter,
        });

        await workspaceSearch.search();

        if (
            workspaceSearch.appResourceCollection.isEmpty &&
            router.currentRoute.name !== 'my.projects'
        ) {
            return router.push({
                name: 'my.projects',
            });
        }

        commit('SET_CURRENT_WORKSPACE', workspaceSearch.appResourceCollection.getFirst());

        await dispatch('initCurrentProjectStages');
        await dispatch('setProperties');
        await dispatch('initCurrentChannels');
        await dispatch('setCurrentWSOrganizationMember');
        await dispatch('setProjectOrgMemberLogInDate');
    },

    async initCurrentChannels({getters, commit}) {
        if (!getters.getWorkspaceUuid) {
            return null;
        }

        const channelsFilter = new ApiFilter({params: {workspaceUuid: getters.getWorkspaceUuid}});
        const channelMembersFilter = new ApiFilter({params: {userUuid: getters.authUser.uuid}});

        channelsFilter.addRelation('members', channelMembersFilter);

        const channels = new AppResourceSearch('channel');

        channels.setSearchData({
            filter: channelsFilter, include: [
                'messages.senderUser.avatarFile',
                'members.user.avatarFile',
                'messages.mentions',
                'messages.channelMemberReads',
                'propertyInstance.property.files',
            ],
        });

        await channels.search();

        const channelsCollection = channels.appResourceCollection;

        commit('SET_CURRENT_WORKSPACE_CHANNELS', channelsCollection);
        commit('SET_ARE_CHANNELS_LOADED', true);

        return channelsCollection;
    },

    async addMembersToChannel({getters}, {members, channelUuid}) {
        const currentUserId = getters.getAuthUserAppResource.uuid;

        for (const workspaceMember of members) {
            const channelMemberResource = new ChannelMemberAppResource({
                attributes: {
                    'userUuid': workspaceMember.get('userUuid'),
                    'channelUuid': channelUuid,
                    'type': workspaceMember.get('userUuid') === currentUserId ? 'admin' : 'member',
                },
            });

            await channelMemberResource.create();
        }
    },

    async addChannelToExistingChannels({commit}, channel) {
        await commit('ADD_CHANNEL_TO_EXISTING_CHANNELS', channel);
    },

    async addMessageToChannel({commit}, {message, channelUuid}) {
        commit('ADD_MESSAGE_TO_CHANNEL', {message, channelUuid});
    },

    async setCurrentWSOrganizationMember({getters, commit}) {
        try {
            const userUuid = getters.getAuthUserAppResource.uuid;
            const projectUuid = getters.getCurrentWorkspace.uuid;
            let membersFilter = new ApiFilter({params: {userUuid: userUuid, workspaceUuid: projectUuid}});

            let projectOrganizationMemberAppResourceSearch = new AppResourceSearch('Workspace-Organization-Member');

            projectOrganizationMemberAppResourceSearch.setSearchData({
                include: [
                    'workspaceRole',
                    'workspaceMembershipType',
                ],
                filter: membersFilter
            });

            await projectOrganizationMemberAppResourceSearch.search();

            let projectOrganizationMemberAppResource =
                projectOrganizationMemberAppResourceSearch.appResourceCollection.getFirst();

            commit('SET_CURRENT_PROJECT_ORGANIZATION_MEMBER', projectOrganizationMemberAppResource);
        } catch (e) {
            throw e;
        }
    },
    async setProjectOrgMemberLogInDate({getters}) {
        const projectOrgMember = getters.getProjectOrganizationMember;

        if (
            typeof projectOrgMember === "undefined" ||
            projectOrgMember === null
        ) {
            return null;
        }

        try {
            let date = moment();
            projectOrgMember.setAttribute('lastLogin', date);
            await projectOrgMember.save(false, false);
        } catch (e) {
            console.warn(e);
        }

    },

    async initCurrentProjectStages({getters, commit}) {
        let stagesSearch = new AppResourceSearch('Stage');

        stagesSearch.setSearchData({
            pagination: 'disabled',
            include: ['stageType'],
            filter: new ApiFilter({
                params: {
                    workspaceUuid: getters.getCurrentWorkspace.uuid,
                }
            })
        });

        await stagesSearch.search();

        commit('SET_CURRENT_PROJECT_STAGES', stagesSearch.appResourceCollection);
    },

    setDefaultMlsAbbreviation({commit}, abbreviation) {
        commit('SET_DEFAULT_MLS_ABBREVIATION', abbreviation);
    },

    setDefaultMapCoordinates({commit}, coords) {
        commit('SET_DEFAULT_MAP_COORDINATES', coords);
    },

    async setBuyFilter({commit}, filter) {
        commit('SET_BUY_FILTER', filter);
    },
};
